/* tslint:disable */
/* eslint-disable */
export enum FirstAidType {
  Aid = 'AID',
  Training = 'TRAINING',
}
